module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_c('i', {
    staticClass: "far fa-question-circle m-r-sm"
  }), _vm._v(" Job Requests")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-789c8c67"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/RequestsHeading.vue
// module id = 1046
// module chunks = 0